import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const RaildaysFeedbackBanner = ({show}) => {
	if (!show) return null;

	return (
		<Box sx={{mx: {xs: 2, md: 3, lg: 5}, mt: {xs: 2, md: 3, lg: 5}}}>
			<Alert severity="success" sx={{alignItems: "center"}}>
				<Typography sx={{fontWeight: 700, textAlign: "center", width: "100%"}}>
					Thank you for your feedback!
				</Typography>
			</Alert>
		</Box>
	);
};

export default RaildaysFeedbackBanner;
